import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyB1MC2eXi1OgM7p1TBxbK0ZUFLrMbRLZSE",
    authDomain: "fb-mern-c0279.firebaseapp.com",
    projectId: "fb-mern-c0279",
    storageBucket: "fb-mern-c0279.appspot.com",
    messagingSenderId: "793639861944",
    appId: "1:793639861944:web:0bc45613cc986a1cf8fe4d"
};

const firebaseApp = firebase.initializeApp(firebaseConfig)

const auth = firebase.auth()
const provider = new firebase.auth.GoogleAuthProvider()
const db = firebase.firestore()

export { auth, provider }
export default db